import { copy } from "./shared";
import CheckoutForm from "./CheckoutForm";
import "../templates/Template3.css";
import "./CheckoutTemplate3.css";

export default function CheckoutTemplate3({ data = {}, code }) {
  const c = copy(data);
  return (
    <div className="clp3-root">
      {/* NAV */}
      <nav>
        <div className="wrap ni">
          <a className="logo cok3-logo">
            {c.logo ? (
              <img src={c.logo} className="site-logo" alt="" />
            ) : (
              <span className="cok3-brandtext">{c.brand}</span>
            )}
          </a>
          <span className="cok3-secure">🔒 Secure checkout</span>
        </div>
      </nav>

      {/* BG SHAPES */}
      <div className="hero-bg">
        <div className="sh1"></div>
        <div className="sh2"></div>
      </div>

      {/* HERO */}
      <section className="hero-bg-img cok3-hero" id="home">
        <div className="hero">
          <div className="cok3-hero-content">
            <span className="cok3-eyebrow">Checkout</span>
            <h1 className="ht">
              Complete your <span className="hl">enrollment</span>
            </h1>
            {c.sub ? <p className="hs">{c.sub}</p> : null}
          </div>
        </div>
      </section>

      {/* FORM + SUMMARY */}
      <div className="wrap">
        <CheckoutForm data={data} code={code} p="cok3" c={c} />
      </div>

      {/* FOOTER */}
      <footer>
        <div className="wrap fi2">
          <div className="cok3-foot">{c.guaranteeOn ? c.guarantee : "© " + c.brand}</div>
        </div>
      </footer>
    </div>
  );
}
